export enum Role {
	ADMIN = "Admin",
	NORMAL = "Normal",
}
